import { brand } from '../../theme/themePrimitives';
import CardWrapper from '../wrapper/card';
import { CustomerObject } from '../../params/redux/customer';
import { formatDateWithTime } from '../../helper';
import { resendCustomerInvitationThunk } from '../../redux/thunks/customer';
import { settingSelectedCustomer } from '../../redux/slices/customer';
import { toast } from 'react-toastify';
import { useParams } from 'react-router';
import { AppDispatch, RootState } from '../../redux/store';
import { Box, Button, CardContent, Divider, IconButton, Typography } from '@mui/material';
import { Delete, Edit, EmailOutlined, PhoneOutlined } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';

interface CustomerCardProps {
    search: string;
    sort: boolean;
    setEditModal: () => void;
    setDeleteModal: () => void;
}

const CustomerCardComponent = ({ search, sort, setDeleteModal, setEditModal }: CustomerCardProps) => {
    const dispatch = useDispatch<AppDispatch>();
    const { id } = useParams<{ id: string }>();
    const { customers } = useSelector((state: RootState) => state.customer);

    // **Filter and Sort Logic**
    const filteredCustomers = customers.filter((customer: CustomerObject) => {
        const name = `${customer.first_name || ''} ${customer.last_name || ''}`.trim();
        const email = customer.email?.toLowerCase() || '';
        const phone = '';
        return (
            !search ||
            name.includes(search.toLowerCase()) ||
            email.includes(search.toLowerCase()) ||
            phone.includes(search)
        );
    });

    const sortedCustomers = sort
        ? [...filteredCustomers].sort((a, b) => a.email.localeCompare(b.email))
        : filteredCustomers;

    const handleDeleteSelection = (value: CustomerObject) => {
        dispatch(settingSelectedCustomer(value));
        setDeleteModal();
    };

    const editDealHandler = (value: CustomerObject) => {
        dispatch(settingSelectedCustomer(value));
        setEditModal();
    };

    const resendInvitation = async (value: CustomerObject) => {
        try {
            // const data: InviteCustomerParams = {
            //     first_name: value.first_name,
            //     last_name: value.last_name,
            //     email: value.email,
            //     phone_number: value.phone_number,
            //     is_primary: value.is_primary,
            // };
            await dispatch(resendCustomerInvitationThunk({ email: value.email, client_id: id ? parseInt(id as string, 10) : 0 })).unwrap();
            toast.success('Resend Invitation Success');
        } catch (e) {
            // Catch errors
        }
    };

    return <Box display="flex" flexWrap="wrap" gap={2} overflow="auto">
        {sortedCustomers.map((row) => (
            <Box key={row.id} minWidth="445px">
                <CardWrapper>
                    <CardContent>
                        <Box display="flex" justifyContent="space-between" alignItems="start" mb={2}>
                            <Box >
                                <Typography variant="h6" minWidth="200px" maxWidth="200px !important" overflow="hidden" textOverflow="ellipsis" >{`${row.first_name} ${row.last_name}`}</Typography>
                                {row.is_primary === 1 && <Box px={2} borderRadius={1} width="max-content" py="0.1rem" bgcolor={brand[50]} color={brand[300]} height="max-content"><Typography variant="body1" fontWeight="bold">Primary</Typography></Box>}
                            </Box>
                            <Box display="flex" alignItems="center">
                                {!row.last_login && <Button variant="outlined" size="small" onClick={() => resendInvitation(row)}>Resend Invitation</Button>}
                                <IconButton onClick={() => editDealHandler(row)}>
                                    <Edit fontSize="small" color="info" />
                                </IconButton>
                                <IconButton onClick={() => handleDeleteSelection(row)}>
                                    <Delete fontSize="small" color="error" />
                                </IconButton>
                            </Box>
                        </Box>
                        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                            <Box display="flex" alignItems="center" gap="5px"><EmailOutlined fontSize="small" /><Typography variant="body2">{row.email}</Typography></Box>
                            <Box display="flex" alignItems="center" gap="5px"><PhoneOutlined fontSize="small" /><Typography variant="body2">{13515135135351}</Typography></Box>
                        </Box>
                        <Divider />
                        <Typography variant="body1" color="textSecondary" mt={2}>Last logged in: <b>{row.last_login ? formatDateWithTime(row.last_login) : 'Pending'}</b></Typography>
                    </CardContent>
                </CardWrapper>
            </Box>
        ))}
        {/* <DeleteDealModal open={showDeleteModal} onClose={() => setShowDeleteModal(false)} /> */}
    </Box>;
};

export default CustomerCardComponent;